import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import kebabCase from 'lodash/kebabCase';
import isUndefined from 'lodash/isUndefined';
import startCase from 'lodash/startCase';
import { commaFormatNumber, replaceCitations } from '@Utils/String';
import { recordCountOrResultsCountFromPreviewItem } from '@Containers/PatentFamilyClustering/selectors';

function BlockLabel({ previewItem, showResultsCount, showTitle, showDatabaseLabel }) {
  const recordCountOrResultsCount = recordCountOrResultsCountFromPreviewItem(previewItem);
  return (
    <div className="results-preview__block__container o-els-flex-layout o-els-flex-layout--left o-els-flex-layout--wrap@mobile rx-align-center">
      <div className="results-preview__block results-preview__block--count">
        {showResultsCount && !isUndefined(recordCountOrResultsCount) && (
          <span className="u-els-font-size-h2">{commaFormatNumber(Number(recordCountOrResultsCount))}</span>
        )}
      </div>
      <div className={cn('results-preview__block', 'results-preview__block--title', kebabCase(previewItem.title))}>
        {showTitle && <h4 className="e2e-quick-results-context-title">{startCase(replaceCitations(previewItem.title))}</h4>}
        {showDatabaseLabel && previewItem.databaseLabel && <div>in {previewItem.databaseLabel}</div>}
      </div>
    </div>
  );
}

BlockLabel.propTypes = {
  previewItem: PropTypes.object.isRequired,
  showResultsCount: PropTypes.bool,
  showDatabaseLabel: PropTypes.bool,
  showTitle: PropTypes.bool,
};

export default BlockLabel;
